import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AdminService } from './admin.service';

@Injectable({
  providedIn: 'root'
})

export class StoreService {


  // httpheader: any = new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem('token') });
  constructor(private http: HttpClient, private adminservice: AdminService) {

  }



  BaseURI: any = this.adminservice.BaseURI;



  //#region Warehouse

  getWarehouselistbyBranchid(branchid: any) {
    return this.http.get(this.BaseURI + '/Warehouses/whlistjson?branchid=' + branchid);
  }

  whlistjson_for_lov(branchid: any) {
    return this.http.get(this.BaseURI + '/Warehouses/whlistjson_for_lov?branchid=' + branchid);
  }

  whlistjson_for_lov_bymultiple_branch(branchids: any) {
    return this.http.get(this.BaseURI + '/Warehouses/whlistjson_for_lov_bymultiple_branch?branchids=' + branchids);
  }

  getWarehouseTypes() {
    return this.http.get(this.BaseURI + '/Warehouses/getwhtypes_for_lov_json');
  }

  getCanteenLov(branchid: any) {
    return this.http.get(this.BaseURI + '/Canteens/lov_json?branchid=' + branchid);
  }

  createCanteen(formData: any) {
    return this.http.post(this.BaseURI + '/Canteens', formData);
  }

  updateCanteen(id: any, formdata: any) {
    return this.http.put(this.BaseURI + '/Canteens/' + id, formdata);
  }

  getCanteenById(id: any) {
    return this.http.get(this.BaseURI + '/Canteens/' + id);
  }

  createWarehouse(formData: any) {
    return this.http.post(this.BaseURI + '/Warehouses', formData);
  }

  updateWarehouse(id: any, formdata: any) {
    return this.http.put(this.BaseURI + '/Warehouses/' + id, formdata)
  }

  getWarehousebyid(id: any) {
    return this.http.get(this.BaseURI + '/Warehouses/' + id);
  }

  getStockLedgerReport_old(whid: any, fromdate: any, todate: any) {
    return this.http.get(this.BaseURI + '/Warehouses/stock_register_json?whid=' + whid + '&fromdate=' + fromdate + '&todate=' + todate);

  }

  getStockLedgerReport(companyid: any, branchids: string | null, whmasterids: string | null, fromdate: any, todate: any) {
    return this.http.get(this.BaseURI + '/Warehouses/get_stok_ledger_report?companyid=' + companyid
      + '&branchids=' + branchids + '&whmasterids=' + whmasterids
      + '&fromdate=' + fromdate + '&todate=' + todate);
  }

  getwarehousebyuserbranchlov(userid: any, companyid: any, branchid: any) {
  return this.http.get(
    this.BaseURI + '/usersbranchmappings/getwarehousebyuserbranchlov?userid='
    + userid + '&companyid=' + companyid + '&branchid=' + branchid
  );
}

  //#endregion

  //#region Material Issue
  getMaterialIssuelistbyBranchid(branchid: any) {
    return this.http.get(this.BaseURI + '/Materialissues/material_issuelistjson?branchid=' + branchid);
  }



  createMaterialIssue(formData: any) {
    return this.http.post(this.BaseURI + '/Materialissues', formData);
  }

  updateMaterialIssue(id: any, formdata: any) {
    return this.http.put(this.BaseURI + '/Materialissues/' + id, formdata)
  }

  getMaterialIssuebyid(id: any) {
    return this.http.get(this.BaseURI + '/Materialissues/get_materialissue_by_id?id=' + id);
  }

  getMaterialIssuePrintById(id: any) {
    return this.http.get(this.BaseURI + '/Materialissues/get_materialissue_print_by_id?id=' + id);
  }

  getIssueTypes() {
    return this.http.get(this.BaseURI + '/Materialissues/getissuetypes_for_lov_json');
  }

  getPendingMaterialIssueRequestCards(branchid: any, whmasterid: any, issuedt: any) {
    return this.http.get(
      this.BaseURI
      + '/Materialissues/get_pending_materialrequest_cards_for_issue?branchid=' + branchid
      + '&whmasterid=' + whmasterid
      + '&issuedt=' + issuedt
    );
  }

  getPendingMaterialIssueItemsByRequest(branchid: any, whmasterid: any, issuedt: any, materialrequestid: any) {
    return this.http.get(
      this.BaseURI
      + '/Materialissues/get_pending_materialrequest_items_for_issue?branchid=' + branchid
      + '&whmasterid=' + whmasterid
      + '&issuedt=' + issuedt
      + '&materialrequestid=' + materialrequestid
    );
  }


  //#endregion

  //#region Material Transfer

  getMaterialTransferlistbyBranchid(branchid: any) {
    return this.http.get(this.BaseURI + '/MaterialTransfers/material_transfer_listjson?branchid=' + branchid);
  }
  getTransporterTypes() {
    return this.http.get(this.BaseURI + '/MaterialTransfers/gettranspotertypes_for_lov_json');
  }


  createMaterialTransfer(formData: any) {
    return this.http.post(this.BaseURI + '/MaterialTransfers', formData);
  }

  updateMaterialTransfer(id: any, formdata: any) {
    return this.http.put(this.BaseURI + '/MaterialTransfers/' + id, formdata)
  }

  getMaterialTransferbyid(id: any) {
    return this.http.get(this.BaseURI + '/MaterialTransfers/get_materialtransfer_by_id?id=' + id);
  }

  getMaterialTransferPrintById(id: any) {
    return this.http.get(this.BaseURI + '/MaterialTransfers/get_materialtransfer_print_by_id?id=' + id);
  }


  //#endregion

  //#region GRN

  getGRNlistbyBranchid(branchid: any) {
    return this.http.get(this.BaseURI + '/GrnMasters/get_grn_listjson?branchid=' + branchid);
  }
  getGRNTypes() {
    return this.http.get(this.BaseURI + '/GrnMasters/getgrntypes_for_lov_json');
  }

  getGRNFromBranchList(branchid: any, trandate: any) {
    return this.http.get(this.BaseURI + '/GrnMasters/get_pending_grn_frombranch_list_for_lov_json?branchid=' + branchid + '&trandate=' + trandate);

  }

  getGRNMaterialTransferCodeWithItemFromBranchId(branchid: any, frombranchid: any, trandate: any) {
    return this.http.get(this.BaseURI + '/GrnMasters/get_pending_grn_itemdtl_frombranch_list_for_lov_json_mtrid?branchid=' + branchid + '&frombranchid=' + frombranchid + '&trandate=' + trandate);

  }


  createGRN(formData: any) {
    return this.http.post(this.BaseURI + '/GrnMasters', formData);
  }

  updateGRN(id: any, formdata: any) {
    return this.http.put(this.BaseURI + '/GrnMasters/' + id, formdata)
  }

  getGRNbyid(id: any) {
    return this.http.get(this.BaseURI + '/GrnMasters/get_grn_by_id?id=' + id);
  }

  getGRNPrintById(id: any) {
    return this.http.get(this.BaseURI + '/GrnMasters/get_grn_print_by_id?id=' + id);
  }

  getGRNVendorList(branchid: any, trandate: any) {
    return this.http.get(this.BaseURI + '/GrnMasters/get_pending_po_vendor_list_for_grn_lov_json?branchid=' + branchid + '&trandate=' + trandate);

  }

  getGRNPOCodeWithItemByVendorid(branchid: any, vendorid: any, trandate: any) {
    return this.http.get(this.BaseURI + '/GrnMasters/get_pending_grn_itemdtl_by_vendorid?branchid=' + branchid + '&vendorid=' + vendorid + '&trandate=' + trandate);

  }


  //#endregion

  //#region Product Opening
  submitOpeningStock(payload: any) {
    return this.http.post(`${this.BaseURI}/Products/upsert_openingstock`, payload);
  }

  //#endregion

  //#region  Material Request

  getMaterialRequestlistbyBranchid(branchid: any) {
    return this.http.get(this.BaseURI + '/materialrequests/material_requestlistjson?branchid=' + branchid);
  }



  createMaterialRequest(formData: any) {
    return this.http.post(this.BaseURI + '/materialrequests', formData);
  }

  updateMaterialRequest(id: any, formdata: any) {
    return this.http.put(this.BaseURI + '/materialrequests/' + id, formdata)
  }

  getMaterialRequestbyid(id: any) {
    return this.http.get(this.BaseURI + '/materialrequests/get_materialrequest_by_id?id=' + id);
  }

  getMaterialRequestPrintById(id: any) {
    return this.http.get(this.BaseURI + '/materialrequests/get_materialrequest_print_by_id?id=' + id);
  }

  //#endregion


  //#region Stock Transfer

  getStockTransferlistbyBranchid(branchid: any) {
    return this.http.get(this.BaseURI + '/StockTransfers/stock_transfer_listjson?branchid=' + branchid);
  }

  getStockTransferTypes() {
    return this.http.get(this.BaseURI + '/StockTransfers/getstocktransfertypes_for_lov_json');
  }

  createStockTransfer(formData: any) {
    return this.http.post(this.BaseURI + '/StockTransfers', formData);
  }

  updateStockTransfer(id: any, formdata: any) {
    return this.http.put(this.BaseURI + '/StockTransfers/' + id, formdata);
  }

  getStockTransferbyid(id: any) {
    return this.http.get(this.BaseURI + '/StockTransfers/get_stocktransfer_by_id?id=' + id);
  }

  getStockTransferPrintById(id: any) {
    return this.http.get(this.BaseURI + '/StockTransfers/get_stocktransfer_print_by_id?id=' + id);
  }

  //#endregion



}
